import { Button, Paper, Rating, TextField, Typography } from '@mui/material';
import { useCourseCore } from '../../../core/modules/course';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

const RatingInfo = () => {
  const { course, rating, getRating, postRating } = useCourseCore();

  const [value, setValue] = useState<number | null>(0);
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (rating) {
      setValue(rating.value);
      setComment(rating.comment);
    }
  }, [rating]);

  const onSubmit = useCallback(() => {
    if (comment && value && value >= 0)
    postRating(course?.id!, { value, comment }, () => {
      setComment("");
      setValue(0);
      getRating(course?.id!);
      toast("Gracias por tu feedback");
    });
  }, [comment, course?.id, getRating, postRating, value]);

  const disabled = useMemo(() => {
    return !!rating;
  }, [rating])

  return (
    <div className="w-full flex justify-center p-16 pb-64 sm:p-24 sm:pb-64 md:p-48 md:pb-64">
      <Paper className="w-full max-w-lg mx-auto sm:my-8 lg:mt-16 p-24 sm:p-40 sm:py-48 rounded-16 shadow">
        <div className="w-full max-w-full text-center">
          <Typography className="text-20 md:text-32 font-extrabold tracking-tight leading-none">
            Dejanos un comentario
          </Typography>
         
          <Rating
            className="mt-24"
            value={value}
            readOnly={disabled}
            onChange={(_, newValue) => {
              setValue(newValue);
            }}
          />

          <TextField
            placeholder="Escribe tu comentario"
            className="w-full mt-24"
            multiline
            rows={5}
            disabled={disabled}
            value={comment}
            onChange={(ev) => setComment(ev.target.value)}
          />
          <Button
            variant="text"
            color="secondary"
            className="mt-24"
            sx={{ borderRadius: 50 }}
            onClick={onSubmit}
            disabled={disabled}
          >
            Enviar
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default RatingInfo;
